import { Common } from '@thecvlb/design-system';

import Collapse from 'shared/Collapse';

import { getContent } from './faq.settings';
import { FAQProps } from './faq.types';

const FAQ: React.FC<FAQProps> = ({ isOpen, onClose, medication, ...props }) => {
  const content = getContent(medication, props);

  return (
    <Common.Modal close={onClose} isOpen={isOpen} size="sm" title="FAQs">
      {content.map((item) => (
        <Collapse key={item.title} title={item.title}>
          {item.content}
        </Collapse>
      ))}
      <Common.Button
        className="mt-6 md:hidden"
        color="white-alt"
        fullWidthOnMobile
        onClick={onClose}
      >
        Close
      </Common.Button>
    </Common.Modal>
  );
};

export default FAQ;
